/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Typography,
} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {themeColors} from '../../theme/Theme';
import {Button} from '../../components/Button/Button';

const HardFactsDummy: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{flex: 1, position: 'relative', p: 1}}>
      <Box
        sx={{
          p: 2,
          pl: 3,
          pr: 3,
          bgcolor: themeColors.lightWarning,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1,
        }}
      >
        <Typography fontWeight={600}>Hard facts coming soon...</Typography>
      </Box>
      <Table sx={{opacity: 0.5}}>
        <TableHead>
          <TableRow>
            {[...Array(5)].map((_, index) => (
              <TableCell
                key={`${index}`}
                sx={{
                  bgcolor: index % 2 === 0 ? theme.palette.grey[100] : 'inherit',
                }}
              />
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(2)].map((_, rowIndex) => (
            <TableRow
              key={rowIndex}
              style={{
                backgroundColor: rowIndex % 2 === 0 ? theme.palette.grey[300] : 'inherit',
                opacity: 0.4,
              }}
            >
              {[...Array(5)].map((__, colIndex) => (
                <TableCell
                  key={colIndex}
                  sx={{
                    bgcolor: colIndex % 2 === 0 ? theme.palette.grey[300] : 'inherit',
                    opacity: 0.4,
                  }}
                />
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box sx={{gap: 2, display: 'flex', opacity: 0.3, pt: 2}}>
        <Button variant="contained" eventName="hard facts dummy" disabled>
          Add row
        </Button>
        <Button variant="contained" eventName="hard facts dummy" disabled>
          Make changes
        </Button>
      </Box>
    </Box>
  );
};

export default HardFactsDummy;
